export default __webpack_public_path__ + "static/small-business-accomplishment-2f-9b1eaa15617dab994369c2286e14501c.webp";